import { useEvent } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Modal } from '@tribeplatform/react-ui-kit/Modal'

import { NotFound } from '../common/components/NotFound.js'
import { T } from '../i18n/index.js'

import { EventDetails } from './EventDetails/EventDetails.js'
import { EventDetailsLoadingSkeleton } from './EventDetailsLoadingSkeleton.js'

interface Props {
  eventId: string
  open: boolean
  onClose: () => void
}

export const EventDetailsModal = ({ eventId, open, onClose }: Props) => {
  const { data: event, isLoading } = useEvent({
    variables: { id: eventId },
    useQueryOptions: {
      enabled: !!eventId,
    },
  })

  return (
    <Modal open={open} onClose={onClose} size="5xl" showCloseBtn>
      <Modal.Content className="my-0 !p-0 bg-surface no-scrollbar">
        {!isLoading && !event && (
          <NotFound
            title={
              <T defaultMessage="Event not found" id="Event.NotFound.Title" />
            }
            description={
              <T
                defaultMessage="We were not able to find the event you’re looking for."
                id="Event.NotFound.Description"
              />
            }
          >
            <Button variant="secondaryNeutral" onClick={onClose}>
              <T defaultMessage="Close" id="Generics.Close" />
            </Button>
          </NotFound>
        )}
        {isLoading && <EventDetailsLoadingSkeleton />}
        {!isLoading && !!event && <EventDetails event={event} />}
      </Modal.Content>
    </Modal>
  )
}
